import { getSvgIcon, InterfaceIcon } from '@helpers/icons';
import { withMotionMax } from '@hoc/withMotionMax';
import { scrollToNextSection } from '@stories/Widgets/Global/ScrollArrow/ScrollArrow';
import { AnimatePresence } from 'framer-motion';
import * as React from 'react';
import S from './ScrollIndicator.styles';
const defaultConfig = {
    threshold: 500,
    delay: 5000,
    currentStep: 1, // Current step in the scroll indicator
};
const ScrollIndicator = (props) => {
    const config = {
        ...defaultConfig,
        ...props.config,
    };
    const [visible, setVisible] = React.useState(false);
    React.useEffect(() => {
        let timeout;
        // Hide the scroll indicator when the user scrolls down a certain amount
        function handleScroll() {
            if (window.scrollY > config.threshold) {
                setVisible(false);
                timeout = 0;
            }
            else {
                // If the user scrolls back up, show the indicator again after a delay
                if (!timeout) {
                    startTimer();
                }
            }
        }
        function startTimer() {
            timeout = window.setTimeout(() => {
                setVisible(true);
                clearTimeout(timeout);
            }, config.delay);
        }
        window.addEventListener('scroll', handleScroll);
        // Initial check
        handleScroll();
        startTimer();
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    return (React.createElement(AnimatePresence, { exitBeforeEnter: true }, visible ? (React.createElement(S.Container, { layoutId: `${props.id}-scroll-indicator`, initial: { opacity: 0, y: 25, x: '-50%' }, animate: { opacity: 1, y: 0, x: '-50%' }, exit: { opacity: 0, y: 25, x: '-50%' }, onClick: () => scrollToNextSection(config.currentStep) },
        Array.from({ length: 3 }).map(() => getSvgIcon(InterfaceIcon.Chevron)),
        props.label ?? React.createElement(React.Fragment, null, "Scroll Down"))) : null));
};
export default withMotionMax(ScrollIndicator);
